/** images */
import React, { useEffect, useState, useContext } from 'react';

import { useNavigate } from 'react-router';

import confetti from 'canvas-confetti';

import ApprovedAmazon from './ApprovedAmazon';

import congratulationImg from '../assets/images/congrats.png';
import cupImg from '../assets/images/cup.png';
import InputRangeSlider from '../components/InputRangeSlider';

/** components */
import Layout from '../components/common/Layout';
import TenantConfig, { getTenant } from '../config';

/** context */
import { UserContext } from '../context/UserContext';

/** helpers */
import { formatUSDCurrency } from '../helpers/format';
import { useRudder } from '../hooks/rudder';

/** service */
import { updateApplication } from '../service/api';

const Approved = () => {
  const navigate = useNavigate();
  const { appData, updateAppData, setLoading } = useContext(UserContext);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [approvedRateProperty, setApprovedRateProperty] = useState({});
  const [confirmValue, setConfirmValue] = useState(0);

  useEffect(() => {
    if (appData) {
      const property = appData?.applicationFeatures?.find(
        (feature) => feature.itemType === 'ApprovedRateProperty'
      );
      setApprovedRateProperty(property);
      setConfirmValue(property?.value?.requestedAmount);
    }
  }, [appData]);

  useEffect(() => {
    setTimeout(() => {
      confetti({ particleCount: 180, spread: 150 });
    }, 750);
  }, []);

  const renderGrantApproved = () => {
    return (
      <div className="approved-page">
        <div className="page-inner">
          <img src={congratulationImg} alt="" className="congratulations" />
          <h2>Congrats! Your grant is approved.</h2>
          <button className="primary-btn" onClick={() => navigate('/docusign')}>
            Accept Grant
          </button>
          <img src={cupImg} alt="" className="cup-image" />
        </div>
      </div>
    );
  };

  const handleLock = async () => {
    setLoading(true);
    const updatedData = await updateApplication([
      {
        itemType: approvedRateProperty.itemType,
        dataType: approvedRateProperty.dataType,
        name: approvedRateProperty.name,
        value: {
          ...approvedRateProperty.value,
          requestedAmount: confirmValue,
        },
      },
    ]);

    if (updatedData.data) {
      updateAppData(updatedData.data);
    }
    window.location.href = approvedRateProperty?.displayProperties?.meta.LINE3;
    setLoading(false);
  };

  const handleRedirect = () => {
    window.location.href = approvedRateProperty?.displayProperties?.meta.LINE3;
  };

  const renderLoanApproved = () => {
    if (getTenant() === 'amazon') {
      return (
        <ApprovedAmazon
          approvedRateProperty={approvedRateProperty}
          handleRedirect={handleRedirect}
          isConfirmed={isConfirmed}
          changeIsConfirmed={(e) => setIsConfirmed(e.target.checked)}
        />
      );
    }
    return (
      <div className="post-submission-page">
        <div className="page-inner">
          <img src={congratulationImg} alt="" className="congratulations" />
          <h2>
            Congrats! You are approved for a loan up to{' '}
            {formatUSDCurrency(approvedRateProperty?.value?.approvedAmount)} at{' '}
            {approvedRateProperty?.value?.approvedApr}% APR for&nbsp;
            {approvedRateProperty?.value?.approvedTerm} months.
          </h2>
          <div className="amount-selection">
            <h2>Do you want to change your amount?</h2>
            <InputRangeSlider
              min={approvedRateProperty?.value?.minApprovedAmount}
              max={approvedRateProperty?.value?.maxApprovedAmount}
              confirmValue={confirmValue}
              setConfirmValue={setConfirmValue}
            />
          </div>
          <div className="CustomCheckBox">
            <div className="terms-checks">
              <label htmlFor="confirm-amount">
                <input
                  type="checkbox"
                  id="confirm-amount"
                  name="confirm-amount-check"
                  checked={isConfirmed}
                  onChange={(e) => setIsConfirmed(e.target.checked)}
                />
                I confirm that I have selected {formatUSDCurrency(confirmValue, 0)}
              </label>
            </div>
          </div>
          <div className="next-step">
            <h2>Next Step</h2>
            <p>{approvedRateProperty?.displayProperties?.meta.LINE1}</p>
            <button className="primary-btn" disabled={!isConfirmed} onClick={handleLock}>
              Lock Amazon Seller Central Bank Account
            </button>
            <div className="description">
              <p>If you need help on how to lock your bank account,</p>
              <p>
                {' '}
                Please see the locking instructions on the Amazon Seller Central{' '}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={'https://sellercentral.amazon.com/gp/help/GPQQ2VAVEHREQYGL'}
                >
                  here.
                </a>
              </p>
            </div>
          </div>
          <img src={cupImg} alt="" className="cup-image" />
        </div>
      </div>
    );
  };

  return (
    <Layout>
      {TenantConfig?.approved.renderLoanApproved ? renderLoanApproved() : renderGrantApproved()}
    </Layout>
  );
};

export default Approved;
